import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { RsfMainSBaseComponent } from '../rsf-main-s-base/rsf-main-s-base.component';
import { FormStatusEnum } from 'src/app/common/enumerations/enumerations';

@Component({
  selector: 'rsf-main-s3',
  templateUrl: './rsf-main-s3.component.html',
  styleUrls: ['./rsf-main-s3.component.scss']
})
export class RsfMainS3Component extends RsfMainSBaseComponent implements OnChanges
{
  noWorkPerformedTitle?: string;
  noWorkPerformedLegend?: string;

  override ngOnChanges(changes: SimpleChanges): void
  {
    super.ngOnChanges(changes);
    this.setMessages();
    this.disabled = this.rsf?.status !== FormStatusEnum.Active && this.rsf?.status !== FormStatusEnum.HoldPoint && this.rsf?.status !== FormStatusEnum.PendingCancelation;

    const signatures = this.rsf?.wfTable?.wfTableLocal?.wfSectionLocals.find(s => s.wfStepLocals?.some(sl => sl.code == 'NO_WORK'))?.wfSignatures;
    const requesterSignature = signatures?.find(s => s.requesterSignature);
    signatures?.forEach(s =>
    {
      if (!s.requesterSignature)
      {
        s.disabled = this.disabled || !requesterSignature?.signed;
      }
    });
  }

  setMessages()
  {
    const titleMsg = this.getMessage("noWorkPerformedTitle");
    const legendMsg = this.getMessage("noWorkPerformedLegend");
    this.noWorkPerformedTitle = titleMsg ? titleMsg.description : '';
    this.noWorkPerformedLegend = legendMsg ? legendMsg.description : '';
  }
}
